// import React from "react";
// import moment from "moment";
import axios from 'axios';
import {
	_axiosCall
} from '../../../helpers/apicalls';
import {
	setLocalStorage,
	getLocalStorage,
	deleteLocalStorage
} from '../../../helpers/utils';
import { _isNewDevSubscriber } from '../../payment/plans';

import buyersListActions from '../../../../redux/actions/buyersListActions';
import { Publisher } from "./../../../pubsub/publisher.js";
const apiUrl = process.env.API_ROOT + '/buyerslist/'
const queryUrl = process.env.API_ROOT + '/query/';
const path = require('path');

// Module-level deduplication: prevents concurrent _getUserSSO calls
let _ssoInFlightPromise = null;

export const removeAtAttributes = (obj) => {
	for (var key in obj) {
		if (!obj.hasOwnProperty(key)) continue;

		if (key.charAt(0) === '@') {
			delete obj[key];
		} else if (typeof obj[key] === 'object' && obj[key] !== null) {
			removeAtAttributes(obj[key]);
		}
	}
}
export const _getUserSSO = async (ssoToken, props, setUserProfile) => {
	// Deduplicate: if an SSO call is already in flight, return the existing promise
	if (_ssoInFlightPromise) {
		return _ssoInFlightPromise;
	}

	const { authState, authService, dispatch } = props;

	const ssoOrg = _getSSOOrg();
	console.log(ssoOrg);

	let ssoPromise;
	if (ssoOrg === "MPSSO") {
		ssoPromise = _getMPUserAuth0SSO(ssoToken, props, setUserProfile);
		//ssoPromise = _getEllimanUserSSO(ssoToken, props, setUserProfile);
	} else if (ssoOrg === "REALPLUS") {
		ssoPromise = _getRealPlusUserSSO(ssoToken, props, setUserProfile);
	} else if (ssoOrg === "ELLIMAN") {
		ssoPromise = _getEllimanUserSSO(ssoToken, props, setUserProfile);
	} else if (ssoOrg === "HOWARDHANNA") {
		ssoPromise = _getHowardHannaUserSSO(ssoToken, props, setUserProfile);
	}

	if (ssoPromise) {
		_ssoInFlightPromise = ssoPromise.finally(() => {
			_ssoInFlightPromise = null;
		});
		return _ssoInFlightPromise;
	}

	// Default CBWarburg flow below
	let headers = {
		"Authorization": `Bearer ${ssoToken.access_token}`,
	}
	let userData = {
		url: `${process.env.REALOGY_BASE_URL}userinfo`,
		method: "get",
		headers: headers
	};
	const allowedEmails = ["previewrlgy@gmail.com", "bonita.lau@cbhome.com"];

	_ssoInFlightPromise = _axiosCall(userData)
		.then(res => {
			console.log("_getUserData res back ,", res);
			if (res) {
				let oktaUser = Object.assign({}, res);
				oktaUser['authType'] = 'sso';
				oktaUser['role'] = ['complete-199'];
				oktaUser['subscriptionPlan'] = 'custom-sso';
				oktaUser['id'] = res.sub;
				oktaUser['firstName'] = res.given_name;
				oktaUser['lastName'] = res.family_name;
				oktaUser['title'] = "Real Estate Professional";
				oktaUser['company'] = "Coldwell Banker Warburg";
				oktaUser['subscriptionId'] = 'custom-sso';
				oktaUser['ssoOrganiztion'] = 'cbwarburg';
				//console.log(oktaUser) 
				//if((oktaUser.email && oktaUser.email.indexOf("cbwarburg.com")>=0)){
				_getUser(oktaUser).then(user => {
					if (user) {

						const combinedUser = Object.assign({}, oktaUser, user);
						dispatch(setUserProfile(combinedUser));
						dispatch(buyersListActions.setUserData(combinedUser));
						Publisher.publish("login", combinedUser);
					} else {
						_checkWarburgAuthorization(oktaUser).then(result => {

							if (result && result.authentication === true || (oktaUser.email && (oktaUser.email.toLowerCase().indexOf("cbrealty.com") >= 0) || allowedEmails.indexOf(oktaUser.email.toLowerCase()) >= 0)) {
								_createUser(oktaUser).then(user => {
									const combinedUser = Object.assign({}, oktaUser, user);
									dispatch(setUserProfile(combinedUser));
									dispatch(buyersListActions.setUserData(combinedUser));
									Publisher.publish("login", combinedUser);
								})
							} else {
								_deleteSSOToken();
								window.location.href = "/cbwarburg?error=unauthorized";
							}


						}).catch(error => {
							console.log(error);
							dispatch(setUserProfile(null));
							_deleteSSOToken();
							window.location.href = "/cbwarburg?error=unauthorized";
						});

					}
				}).catch(error => {
					console.log(error);
					dispatch(setUserProfile(null));
					_deleteSSOToken();
					window.location.href = "/cbwarburg?error=unauthorized";
				});
				//   }else{
				// 	window.location.href = "/login";
				// }
			} else {
				dispatch(setUserProfile(null));
				_deleteSSOToken();
				window.location.href = "/cbwarburg?error=unauthorized";
			}


		})
		.catch(error => {

			if (error && error.status && error.status == 401) {
				console.log("error 401")
				dispatch(setUserProfile(null));
				_deleteSSOToken();
			}
			console.log(error)

		}).finally(() => {
			_ssoInFlightPromise = null;
		});
	return _ssoInFlightPromise;
}

export const _getMPUserSSO = async (ssoToken, props, setUserProfile) => {

	const { authState, authService, dispatch } = props;

	let headers = {
		"Authorization": `Bearer ${ssoToken.access_token}`,
	}
	let userData = {
		url: `${process.env.MP_BASE_URL}userinfo`,
		method: "get",
		headers: headers
	};


	return _axiosCall(userData)
		.then(res => {
			console.log("_getUserData res back ,", res);
			if (res) {

				let oktaUser = Object.assign({}, res);
				oktaUser['id'] = res.sub;
				oktaUser['authType'] = 'sso';
				oktaUser['ssoType'] = 'MPSSO';
				oktaUser['avatar'] = oktaUser['avatar'] ? oktaUser['avatar'] : "https://buyerslist.s3.amazonaws.com/account.png";
				if (res.AllProfile) {
					oktaUser = Object.assign({}, oktaUser, res.AllProfile);
				}
				_getUser(oktaUser).then(user => {
					console.log(user)
					if (user) {

						const combinedUser = Object.assign({}, user, oktaUser);
						dispatch(setUserProfile(combinedUser));
						dispatch(buyersListActions.setUserData(combinedUser));
						Publisher.publish("login", combinedUser);
					} else {
						dispatch(setUserProfile(oktaUser));
						Publisher.publish("login", (oktaUser));
						//_deleteSSOToken();

					}
				}).catch(error => {
					console.log(error);
					dispatch(setUserProfile(null));
					_deleteSSOToken();
				});
			} else {
				dispatch(setUserProfile(null));
				_deleteSSOToken();
			}


		})
		.catch(error => {

			if (error && error.status && error.status == 401) {
				console.log("error 401")
				dispatch(setUserProfile(null));
				_deleteSSOToken();
			}
			console.log(error)

		});
}

export const _getMPUserAuth0SSO = function (ssoToken, props, setUserProfile) {
	var dispatch = props && props.dispatch ? props.dispatch : function () { };

	var apiBase = '';
	if (typeof process !== 'undefined' && process.env && process.env.API_ROOT) {
		apiBase = String(process.env.API_ROOT).replace(/\/+$/, '');
	}
	var meUrl = apiBase ? (apiBase + '/auth0/me') : '/auth0/me';

	var idToken = ssoToken && ssoToken.id_token ? ssoToken.id_token : '';

	// POST with token in query to avoid preflight
	var userData = {
		url: meUrl,
		method: 'post',
		query: { token: idToken }
	};

	function finishAndReturn(combinedUser) {
		try {
			combinedUser['avatar'] = combinedUser['avatar'] ? combinedUser['avatar'] : "https://buyerslist.s3.amazonaws.com/account.png";
			console.log(combinedUser);
			dispatch(setUserProfile(combinedUser));
			if (typeof buyersListActions !== 'undefined' &&
				buyersListActions &&
				buyersListActions.setUserData) {

				dispatch(buyersListActions.setUserData(combinedUser));
			}
			if (typeof Publisher !== 'undefined' && Publisher && Publisher.publish) {
				Publisher.publish('login', combinedUser);
			}


		} catch (e) {
			console.log(e);
		}
		return combinedUser;
	}

	return _axiosCall(userData)
		.then(function (srvProfile) {
			try {
				if (!srvProfile || typeof srvProfile !== 'object') {
					dispatch(setUserProfile(null));
					_deleteSSOToken();
					return null;
				}

				// Build app user from flattened server profile
				var rawUserId = srvProfile.user_id || '';
				// Remove "auth0|okta|" prefix if present
				var cleanedId = rawUserId.replace(/^auth0\|okta\|/, '');

				var auth0User = Object.assign({}, srvProfile, {
					id: cleanedId,
					user_id: cleanedId,
					authType: 'sso',
					ssoType: 'AUTH0'
				});
				console.log(srvProfile);
				if (srvProfile && srvProfile.user_metadata && typeof srvProfile.user_metadata === 'object') {
					auth0User = Object.assign({}, auth0User, srvProfile.user_metadata);
				}
				if (srvProfile && srvProfile.app_metadata && typeof srvProfile.app_metadata === 'object') {
					auth0User = Object.assign({}, auth0User, srvProfile.app_metadata);
				}

				// Normalize groups
				if (!Array.isArray(auth0User.groups)) auth0User.groups = [];

				// Avatar fallback
				if (!auth0User.avatar) {
					if (auth0User.picture) auth0User.avatar = auth0User.picture;
					else auth0User.avatar = 'https://buyerslist.s3.amazonaws.com/account.png';
				}

				// Try to fetch existing user
				return _getUser(auth0User)
					.then(function (user) {
						if (user) {
							// Match your example: DB user overrides SSO fields
							var combinedUser = Object.assign({}, user, auth0User);
							return finishAndReturn(combinedUser);
						} else {
							// Create user if not found
							return _createUser(auth0User)
								.then(function (newUser) {
									var combinedUser = Object.assign({}, newUser, auth0User);
									return finishAndReturn(combinedUser);
								})
								.catch(function (createErr) {
									console.log(createErr);
									dispatch(setUserProfile(null));
									_deleteSSOToken();
									return null;
								});
						}
					})
					.catch(function (getErr) {
						// If API signals not found, attempt create
						if (getErr && getErr.status === 404) {
							return _createUser(auth0User)
								.then(function (newUser) {
									var combinedUser = Object.assign({}, newUser, auth0User);
									return finishAndReturn(combinedUser);
								})
								.catch(function (createErr) {
									console.log(createErr);
									dispatch(setUserProfile(null));
									_deleteSSOToken();
									return null;
								});
						}
						console.log(getErr);
						dispatch(setUserProfile(null));
						_deleteSSOToken();
						return null;
					});
			} catch (e) {
				console.log(e);
				dispatch(setUserProfile(null));
				_deleteSSOToken();
				return null;
			}
		})
		.catch(function (error) {
			if (error && error.status && error.status === 401) {
				console.log('error 401');
				dispatch(setUserProfile(null));
				_deleteSSOToken();
			}
			console.log(error);
			return null;
		});
};



export const _getRealPlusUserSSO = async (ssoToken, props, setUserProfile) => {

	const { authState, authService, dispatch } = props;

	let headers = {
		"Authorization": `Bearer ${ssoToken.access_token}`,
	}
	let userData = {
		url: `${process.env.REALPLUS_BASE_URL}userinfo`,
		method: "get",
		headers: headers
	};


	return _axiosCall(userData)
		.then(res => {
			console.log("_getUserData res back ,", res);
			if (res) {
				let oktaUser = Object.assign({}, res);
				let nameParts = res.name.split(' ');
				let first_name = nameParts[0]
				let last_name = nameParts[nameParts.length - 1]
				oktaUser['authType'] = 'sso';
				oktaUser['role'] = ['complete-199'];
				oktaUser['subscriptionPlan'] = 'custom-sso';
				oktaUser['id'] = res.sub;
				oktaUser['firstName'] = first_name;
				oktaUser['lastName'] = last_name;
				oktaUser['title'] = "Real Estate Professional";
				oktaUser['subscriptionId'] = 'custom-sso';
				oktaUser['ssoOrganiztion'] = 'realplus';
				//console.log(oktaUser) 
				//if((oktaUser.email && oktaUser.email.indexOf("cbwarburg.com")>=0)){
				_getUser(oktaUser).then(user => {
					if (user) {

						const combinedUser = Object.assign({}, oktaUser, user);
						dispatch(setUserProfile(combinedUser));
						dispatch(buyersListActions.setUserData(combinedUser));
						Publisher.publish("login", combinedUser);
					} else {

						_createUser(oktaUser).then(user => {
							const combinedUser = Object.assign({}, oktaUser, user);
							dispatch(setUserProfile(combinedUser));
							dispatch(buyersListActions.setUserData(combinedUser));
							Publisher.publish("login", combinedUser);
						})

					}
				}).catch(error => {
					console.log(error);
					dispatch(setUserProfile(null));
					_deleteSSOToken();
					window.location.href = "/realplus?error=unauthorized";
				});
				//   }else{
				// 	window.location.href = "/login";
				// }
			} else {
				dispatch(setUserProfile(null));
				_deleteSSOToken();
				window.location.href = "/realplus?error=unauthorized";
			}


		})
		.catch(error => {

			if (error && error.status && error.status == 401) {
				console.log("error 401")
				dispatch(setUserProfile(null));
				_deleteSSOToken();
			}
			console.log(error)

		});
}

export const _getEllimanUserSSO = async (ssoToken, props, setUserProfile) => {
	const { dispatch } = props;
	const claims = ssoToken.claims || {};

	 //claims.sub = "k84djFmXCAoYcLzZZH7fgAJrlPtIN4_Ora5gnvOj5R0";
	 //claims.oid = "6c4926cd-b82d-4cec-9ac5-7b5a99c34195";
	 //ssoToken.access_token = "eyJ0eXAiOiJKV1QiLCJub25jZSI6IlpKakxSSUdxVVUwMEJSUUxVajZGdUNicWU1c0VkbDROWHhtbzNnSHZwTWMiLCJhbGciOiJSUzI1NiIsIng1dCI6IlFaZ045SHFOa0dORU00R2VLY3pEMDJQY1Z2NCIsImtpZCI6IlFaZ045SHFOa0dORU00R2VLY3pEMDJQY1Z2NCJ9.eyJhdWQiOiIwMDAwMDAwMy0wMDAwLTAwMDAtYzAwMC0wMDAwMDAwMDAwMDAiLCJpc3MiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8zNmU5Yzg2ZS0yYzFkLTQzNzQtYmEzMS1jNGI4OGFjYWJjZTEvIiwiaWF0IjoxNzc1MjI5NDkxLCJuYmYiOjE3NzUyMjk0OTEsImV4cCI6MTc3NTIzNDk1NiwiYWNjdCI6MCwiYWNyIjoiMSIsImFjcnMiOlsicDEiXSwiYWlvIjoiQVhRQWkvOGJBQUFBaVlnajRlVkNKb1F1Q0hvRjVlbklGUDAyczdSMHV1NVJzWi9zRXdBV29GY0lURzR4Tm5RelIxV01UZDBvSlZwdlcxcldTSmErK0pyejBGZ0tTdVpnVjBvVHRTaHBvTFd1amlKVTdZYlU3Snd3SkpsMXdOam55OUNvZmFmenlSMTNwSVRoSjF5UVlsclFSZVgrYkd1VGZRPT0iLCJhbXIiOlsicHdkIiwibWZhIl0sImFwcF9kaXNwbGF5bmFtZSI6Ik1hcmtldHByb29mIFBybyIsImFwcGlkIjoiYjhhNGJmZDAtM2FiNi00ZGM4LTgzNmYtNDE0NGU3YjlkYmJmIiwiYXBwaWRhY3IiOiIwIiwiZ2l2ZW5fbmFtZSI6IlRlc3RfbWt0cHJvb2YiLCJpZHR5cCI6InVzZXIiLCJpcGFkZHIiOiIxNzQuNDQuMjEzLjEzMSIsIm5hbWUiOiJUZXN0X21rdHByb29mIiwib2lkIjoiNmM0OTI2Y2QtYjgyZC00Y2VjLTlhYzUtN2I1YTk5YzM0MTk1Iiwib25wcmVtX3NpZCI6IlMtMS01LTIxLTE2NDQ0OTE5MzctMjg3MjE4NzI5LTgzOTUyMjExNS0xNjkyNjAiLCJwbGF0ZiI6IjUiLCJwdWlkIjoiMTAwMzIwMDRCMzc5OERDMiIsInJoIjoiMS5BUVFBYnNqcE5oMHNkRU82TWNTNGlzcTg0UU1BQUFBQUFBQUF3QUFBQUFBQUFBQUVBVzRFQUEuIiwic2NwIjoiZW1haWwgb3BlbmlkIHByb2ZpbGUgVXNlci5SZWFkIFVzZXIuUmVhZC5BbGwiLCJzaWQiOiIwMDEyN2U3YS02MWMwLTZjYWUtYjcxZS00NDAzYTlmMWFlZmUiLCJzaWduaW5fc3RhdGUiOlsia21zaSJdLCJzdWIiOiJMNTFGOXlaMG9Ga2x3VHlmYklwU2lwWFZSbjNUeU1xeXMwT1R2R2dQREJVIiwidGVuYW50X3JlZ2lvbl9zY29wZSI6Ik5BIiwidGlkIjoiMzZlOWM4NmUtMmMxZC00Mzc0LWJhMzEtYzRiODhhY2FiY2UxIiwidW5pcXVlX25hbWUiOiJUZXN0X21rdHByb29mQGVsbGltYW4uY29tIiwidXBuIjoiVGVzdF9ta3Rwcm9vZkBlbGxpbWFuLmNvbSIsInV0aSI6IkRpZ3hvYlRHOTAyTmVpa0JVeDRfQUEiLCJ2ZXIiOiIxLjAiLCJ3aWRzIjpbImI3OWZiZjRkLTNlZjktNDY4OS04MTQzLTc2YjE5NGU4NTUwOSJdLCJ4bXNfYWNkIjoxNzQ3MDc1OTkwLCJ4bXNfYWN0X2ZjdCI6IjkgMyIsInhtc19mdGQiOiIxUXkxSVFiVmk0UE5tN3A2bml3TnNRYWUtd1ZSVWJfTUtXaFJCS19Tamx3QmRYTmxZWE4wTFdSemJYTSIsInhtc19pZHJlbCI6IjEwIDEiLCJ4bXNfcGZ0ZXhwIjoxNzc1MzIxMzU2LCJ4bXNfc3QiOnsic3ViIjoiazg0ZGpGbVhDQW9ZY0x6WlpIN2ZnQUpybFB0SU40X09yYTVnbnZPajVSMCJ9LCJ4bXNfc3ViX2ZjdCI6IjEyIDMiLCJ4bXNfdGNkdCI6MTMzMzA0MDk0MSwieG1zX3RudF9mY3QiOiIzIDYifQ.WgkdgJA51577HC3m5BTcnHB_yBxcc98mYujLoXEDZcuzW4zZz6OEmUyiR6UD6WYxWACPZ7af9DB2vBNVQX3bJjAfAytteFajmeM8tYvHDjB3c997mzjlwpj_1CgSac2wU7wJB8E-a7bgdPTuXmZz2PHN_PFGqi0JF-pcTuCRkQDctnhhPOAw2qt5Ry7INrqTiN3nG84xk_jBYAHZ_nHa9owTZjoWT-5fFnQpJqS6TgCN30ZfPhYWwR5ae7MkeO3KQqWZYcVabpnlJVSqUksjeoZ2OlnxcliCUTaMGllI6J1mMBJxzXalrQee1exRL9peYUgaLJMrvZOCztPxUSZ8pw";
	const userId = claims.oid;

	const headers = {
		Authorization: 'Bearer ' + ssoToken.access_token
	};

	var partialUser = {
		id: claims.sub,
		ssoOID: userId,
		ssoType: 'ELLIMAN',
		authType: 'sso'
	};

	return _getUser(partialUser).then(async function (user) {
		var hasAvatar = user && user.avatar;
		var allowedStates = ['ny', 'new york'];
		var normalizedState = user && user.state ? user.state.trim().toLowerCase() : '';
		var isNYUser = allowedStates.indexOf(normalizedState) >= 0 || !user || !user.state;

		if (user && hasAvatar) {
			var finalUser = {
				...user,
				avatar: user.avatar,
				corpLogo: 'https://marketproof-hosting.s3.us-east-1.amazonaws.com/themes/douglas-elliman/elliman-logo.png'
			};

			if (!isNYUser) {
				dispatch(setUserProfile(null));
				_deleteSSOToken();
				window.location.href = '/elliman?error=unauthorized';
				return;
			}

			dispatch(setUserProfile(finalUser));
			dispatch(buyersListActions.setUserData(finalUser));
			Publisher.publish('login', finalUser);
			Publisher.publish('track-mp.userLogin.ssoMSGraphProfile', { user: finalUser, customData: finalUser });
			return;
		}

		var graphUser = await _axiosCall({
			url: 'https://graph.microsoft.com/v1.0/users/' + userId + '?$select=id,displayName,givenName,surname,jobTitle,department,officeLocation,city,state,postalCode,streetAddress,mail,mobilePhone,businessPhones,aboutMe,employeeType,department,createdDateTime,employeeId,userPrincipalName',
			method: 'get',
			headers: headers
		});

		Publisher.publish('track-mp.userLogin.ssoFetchMSProfile', {
			user: user, customData: {
				url: 'https://graph.microsoft.com/v1.0/users/' + userId + '?$select=id,displayName,givenName,surname,jobTitle,department,officeLocation,city,state,postalCode,streetAddress,mail,mobilePhone,businessPhones,aboutMe,employeeType,department,createdDateTime,employeeId,userPrincipalName',
				method: 'get',
				headers: headers
			}
		});

		logToLocalStorage("sso_graph_call", {
			url: 'https://graph.microsoft.com/v1.0/users/' + userId + '?$select=id,displayName,givenName,surname,jobTitle,department,officeLocation,city,state,postalCode,streetAddress,mail,mobilePhone,businessPhones,aboutMe,employeeType,department,createdDateTime,employeeId,userPrincipalName',
			method: 'get',
			headers: headers
		});

		if (!graphUser) {
			dispatch(setUserProfile(null));
			_deleteSSOToken();
			window.location.href = '/elliman?error=unauthorized';
			return;
		}

		var avatarUrl = 'https://marketproof-hosting.s3.us-east-1.amazonaws.com/themes/douglas-elliman/de-avatar-light.png';

		try {
			var photoRes = await axios.get(
				'https://graph.microsoft.com/v1.0/users/' + userId + '/photo/$value',
				{
					headers: headers,
					responseType: 'blob'
				}
			);

			if (photoRes.status === 200 && photoRes.data instanceof Blob) {
				var file = new File([photoRes.data], 'avatar.jpg', { type: photoRes.data.type });
				var formData = new FormData();
				formData.append('file', file);

				var uploadUrl = process.env.API_ROOT + '/buyerslist/imageupload';
				var uploadRes = await axios.post(uploadUrl, formData, {
					headers: { 'Content-Type': 'multipart/form-data' }
				});

				if (uploadRes.data && uploadRes.data[0]) {
					avatarUrl = uploadRes.data[0];
				}
			}
		} catch (err) {
			console.log('Photo fetch or upload failed:', err);
		}

		var oktaUser = {
			...graphUser,
			id: claims.sub,
			authType: 'sso',
			ssoType: 'ELLIMAN',
			title: graphUser.jobTitle || 'Real Estate Professional',
			company: 'Douglas Elliman',
			subscriptionPlan: 'custom-sso',
			subscriptionId: 'custom-sso',
			role: ['broker-outreach', 'elliman-agent'],
			firstName: graphUser.givenName,
			lastName: graphUser.surname,
			ssoOrganiztion: 'elliman',
			ssoOID: userId,
			email: graphUser.mail || graphUser.userPrincipalName,
			mobilePhone: graphUser.mobilePhone || null,
			primaryPhone: (graphUser.businessPhones && graphUser.businessPhones.length > 0) ? graphUser.businessPhones[0] : null,
			office: graphUser.officeLocation || null,
			streetAddress: graphUser.streetAddress || null,
			city: graphUser.city || null,
			state: graphUser.state || null,
			zipCode: graphUser.postalCode || null,
			biography: graphUser.aboutMe || null,
			avatar: avatarUrl,
			corpLogo: 'https://marketproof-hosting.s3.us-east-1.amazonaws.com/themes/douglas-elliman/elliman-logo.png',
			website: 'https://elliman.com',
			downloadAccess: 'manual',
			mcTheme: 'elliman',
			monthlyDataCreditOverride: 25
		};

		// if (claims.sub === "k84djFmXCAoYcLzZZH7fgAJrlPtIN4_Ora5gnvOj5R0") {
		// 	oktaUser.role.push('skip-trace');
		// }

		var userDetails = {};
		if (oktaUser && oktaUser.email && oktaUser.email != "") {
			try {
				var agentCall = {
					url: queryUrl + "search-agents?cache=refresh",
					method: "post",
					query: {
						q: `email:("${oktaUser.email.toLowerCase()}")`,
						fq: ["source_namespace:ELLIMAN-AGENTS-DIRECT", "deleted:false"],
						sort: "solr_updated_date desc",
						rows: 1
					}
				}
				logToLocalStorage("sso_agent_call", agentCall);
				var agentRes = await _axiosCall(agentCall);

				if (agentRes && agentRes.docs && agentRes.docs[0]) {
					let agentDoc = agentRes.docs[0];
					if (agentDoc.description && agentDoc.description != "") {
						oktaUser["biography"] = agentDoc.description;
					}
					if (agentDoc.title && agentDoc.title != "") {
						oktaUser["title"] = agentDoc.title;
					}
					if (agentDoc.image_thumbnail && agentDoc.image_thumbnail != "") {
						oktaUser["avatar"] = agentDoc.image_thumbnail;
					} else if (agentDoc.image && agentDoc.image !== "") {
						const uploadUrl = process.env.API_ROOT + '/buyerslist/imageupload-resize-url';

						// Send JSON body instead of FormData
						const uploadRes = await axios.post(uploadUrl, {
							url: agentDoc.image,
							width: 400
							// height: 800 // optional, defaults to auto
						});

						if (uploadRes.data && uploadRes.data[0]) {
							oktaUser["avatar"] = uploadRes.data[0]; // URL returned by your API
						}
					}
				}
				logToLocalStorage("sso_agent_res", agentRes);
			} catch (err) {
				console.log('agent fetch failed:', err);
			}
		}

		removeAtAttributes(oktaUser);

		var normalizedState2 = oktaUser.state ? oktaUser.state.trim().toLowerCase() : '';
		var isNYUser2 = allowedStates.indexOf(normalizedState2) >= 0 || !oktaUser.state;

		const exceptionList = ["kristen.perkins@elliman.com"]; // keep all lowercased

		var email = "";
		if (oktaUser && oktaUser.email) {
			email = String(oktaUser.email).trim().toLowerCase();
		}

		var exceptionAllowed = email && exceptionList.indexOf(email) !== -1;

		if (!isNYUser2 && !exceptionAllowed) {
			dispatch(setUserProfile(null));
			_deleteSSOToken();
			window.location.href = "/elliman?error=unauthorized";
			return;
		}

		var finalUser;
		if (!user) {
			finalUser = await _createUser(oktaUser).then(function (created) {
				return { ...oktaUser, ...created };
			});
			Publisher.publish('track-mp.userLogin.ssoCreateUser', { user: finalUser, customData: finalUser });
		} else {
			finalUser = {
				...oktaUser,
				...Object.fromEntries(
					Object.entries(user).filter(function (entry) {
						var key = entry[0];
						var value = entry[1];
						return (
							value !== false &&
							value !== null &&
							value !== '' &&
							key !== 'avatar' &&
							key !== 'corpLogo'
						);
					})
				),
				avatar: oktaUser.avatar,
				corpLogo: oktaUser.corpLogo
			};
		}

		if (user && (!user.avatar || user.avatar === '')) {
			var updateData = {
				id: user.id,
				avatar: avatarUrl
			};

			var updateUserPayload = {
				url: apiUrl + 'user/update',
				method: 'post',
				query: {
					id: updateData.id,
					profile: updateData
				}
			};

			try {
				var updateRes = await _axiosCall(updateUserPayload);
				if (updateRes && updateRes.profile) {
					finalUser = {
						...finalUser,
						...updateRes.profile,
						id: updateRes.id,
						avatar: avatarUrl // make sure it's not overwritten
					};
				}
			} catch (e) {
				console.log('Avatar profile update failed', e);
			}
		}

		dispatch(setUserProfile(finalUser));
		dispatch(buyersListActions.setUserData(finalUser));
		Publisher.publish('login', finalUser);
		Publisher.publish('track-mp.userLogin.ssoMSGraphProfile', { user: finalUser, customData: finalUser });
	}).catch(function (error) {
		if (error && error.status === 401) {
			dispatch(setUserProfile(null));
			_deleteSSOToken();
		}
		console.log('Elliman user fetch error:', error);
	});
};


export const _getHowardHannaUserSSO = async (ssoToken, props, setUserProfile) => {
	const { dispatch } = props;
	const claims = ssoToken.claims || {};

	let headers = {
		"Authorization": `Bearer ${ssoToken.access_token}`,
	};
	let userData = {
		url: `${process.env.HOWARDHANNA_BASE_URL}oauth2/v1/userinfo`,
		method: "get",
		headers: headers
	};

	return _axiosCall(userData)
		.then(async res => {
			if (!res) {
				dispatch(setUserProfile(null));
				_deleteSSOToken();
				window.location.href = "/hhnyc?error=unauthorized";
				return;
			}

			let nameParts = (res.name || '').split(' ');
			let oktaUser = {
				...res,
				id: res.sub,
				authType: 'sso',
				ssoType: 'HOWARDHANNA',
				ssoOrganiztion: 'howardhanna',
				firstName: res.given_name || nameParts[0] || '',
				lastName: res.family_name || nameParts[nameParts.length - 1] || '',
				title: res.title || 'Real Estate Professional',
				company: 'Howard Hanna NYC',
				subscriptionPlan: 'custom-sso',
				subscriptionId: 'custom-sso',
				role: ['complete-199'],
				avatar: res.picture || 'https://buyerslist.s3.amazonaws.com/account.png',
				corpLogo: 'https://marketproof-hosting.s3.us-east-1.amazonaws.com/themes/howardhanna/hh-logo.png',
			};

			// First try lookup by Okta sub (returning SSO users)
			let user = await _getUser(oktaUser);

			// If not found, try email-based lookup to link existing Auth0 accounts
			if (!user && oktaUser.email) {
				user = await _getUser({ id: oktaUser.email });
			}

			if (user) {
				const combinedUser = Object.assign({}, oktaUser, user, {
					avatar: user.avatar || oktaUser.avatar,
					corpLogo: oktaUser.corpLogo,
					authType: 'sso',
					ssoType: 'HOWARDHANNA',
				});
				dispatch(setUserProfile(combinedUser));
				dispatch(buyersListActions.setUserData(combinedUser));
				Publisher.publish("login", combinedUser);
			} else {
				_createUser(oktaUser).then(newUser => {
					const combinedUser = Object.assign({}, oktaUser, newUser || {});
					dispatch(setUserProfile(combinedUser));
					dispatch(buyersListActions.setUserData(combinedUser));
					Publisher.publish("login", combinedUser);
				}).catch(err => {
					console.log('HowardHanna createUser error:', err);
					dispatch(setUserProfile(null));
					_deleteSSOToken();
					window.location.href = "/hhnyc?error=unauthorized";
				});
			}
		})
		.catch(error => {
			console.log('HowardHanna userinfo error:', error);
			if (error && error.status === 401) {
				dispatch(setUserProfile(null));
				_deleteSSOToken();
			}
		});
};

export const _doUserHowardHannaSSOLogout = async (props, setUserProfile) => {
	const { dispatch } = props;
	const ssoToken = _getSSOToken();
	const idTokenHint = ssoToken && ssoToken.id_token ? `&id_token_hint=${ssoToken.id_token}` : '';
	const logURL = `${process.env.HOWARDHANNA_BASE_URL}oauth2/v1/logout?client_id=${process.env.HOWARDHANNA_CLIENT_ID}${idTokenHint}&post_logout_redirect_uri=${encodeURIComponent(process.env.HOWARDHANNA_LOGOUT_REDIRECT_URI)}`;

	_deleteSSOToken();
	dispatch(setUserProfile(null));
	Publisher.publish("logout", {});
	window.location.href = logURL;
	return false;
};

export const _getUser = async (user) => {

	let axiosData = {
		url: `${process.env.API_ROOT}/buyerslist/userdata/${user.id}`,
		method: "get"
	};
	let formattedData = await _axiosCall(axiosData)
		.then(res => {
			if (res && res.length > 0) {
				return res[0];
			} else {
				return false;
			}
		})
		.catch(error => {
			console.log("error: " + error);
		});
	return formattedData;
};

export const _createUser = async (user) => {

	let axiosData = {
		url: `${process.env.API_ROOT}/buyerslist/createssouser/${user.id}`,
		method: "post",
		query: user
	};

	let formattedData = await _axiosCall(axiosData)
		.then(res => {
			console.log('Data', res);
			if (res && res.length > 0) {
				return res[0];
			} else {
				return false;
			}
		})
		.catch(error => {
			console.log("error: " + error);
		});

	// console.log(formattedData)
	return formattedData;
};


export const _doUserSSOLogout = async (props, setUserProfile) => {
	const { authState, authService, dispatch } = props;
	const ssoOrg = _getSSOOrg();

	if (ssoOrg === "MPSSO") {
		//return _doUserMPSSOLogout(props, setUserProfile);
		return _doUserMPAuth0SSOLogout(props, setUserProfile);
	} else if (ssoOrg === "REALPLUS") {
		return _doUserRealPlusSSOLogout(props, setUserProfile);
	} else if (ssoOrg === "ELLIMAN") {
		return _doUserEllimanSSOLogout(props, setUserProfile);
	} else if (ssoOrg === "HOWARDHANNA") {
		return _doUserHowardHannaSSOLogout(props, setUserProfile);
	}

	const ssoToken = _getSSOToken();
	if (ssoToken && ssoToken.id_token) {
		const logURL = `${process.env.REALOGY_BASE_URL}logout?client_id=${process.env.REALOGY_CLIENT_ID}&id_token_hint=${ssoToken.id_token}&post_logout_redirect_uri=${process.env.REALOGY_LOGOUT_REDIRECT_URI}`;
		_deleteSSOToken();

		Publisher.publish("logout", {});
		window.location.href = logURL;
		//dispatch(setUserProfile(null));
		return false;
	}
}

export const _doUserRealPlusSSOLogout = async (props, setUserProfile) => {
	const { authState, authService, dispatch } = props;
	const ssoToken = _getSSOToken();
	if (ssoToken && ssoToken.id_token) {
		const logURL = `${process.env.REALPLUS_BASE_URL}logout?client_id=${process.env.REALPLUS_CLIENT_ID}&id_token_hint=${ssoToken.id_token}&post_logout_redirect_uri=${process.env.REALPLUS_LOGOUT_REDIRECT_URI}`;
		_deleteSSOToken();

		Publisher.publish("logout", {});
		window.location.href = logURL;
		//dispatch(setUserProfile(null));
		return false;
	}
}

export const _doUserMPSSOLogout = async (props, setUserProfile) => {
	const { authState, authService, dispatch } = props;
	const ssoToken = _getSSOToken();
	if (ssoToken && ssoToken.id_token) {
		const logURL = `${process.env.MP_BASE_URL}logout?client_id=${process.env.MP_CLIENT_ID}&id_token_hint=${ssoToken.id_token}&post_logout_redirect_uri=${process.env.MP_LOGOUT_REDIRECT_URI}`;
		_deleteSSOToken();

		Publisher.publish("logout", {});
		window.location.href = logURL;
		//dispatch(setUserProfile(null));
		return false;
	}
}
export const _doUserMPAuth0SSOLogout = function (props, setUserProfile) {
	var dispatch = props && props.dispatch ? props.dispatch : function () { };

	// Build Auth0 logout URL
	var auth0Base = '';
	if (typeof process !== 'undefined' && process.env && process.env.REACT_APP_AUTH0_DOMAIN) {
		auth0Base = String(process.env.REACT_APP_AUTH0_DOMAIN).replace(/\/+$/, '');
		if (auth0Base.indexOf('http') !== 0) auth0Base = 'https://' + auth0Base;
	}

	var clientId = '';
	if (typeof process !== 'undefined' && process.env) {
		if (process.env.REACT_APP_AUTH0_CLIENT_ID) clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
		else if (process.env.MP_CLIENT_ID) clientId = process.env.MP_CLIENT_ID; // fallback if you reuse envs
	}

	var returnTo = '';
	if (typeof process !== 'undefined' && process.env) {
		if (process.env.MP_LOGOUT_REDIRECT_URI) returnTo = process.env.MP_LOGOUT_REDIRECT_URI;
	}
	if (!returnTo && typeof window !== 'undefined' && window.location && window.location.origin) {
		returnTo = window.location.origin;
	}

	var logoutURL = auth0Base + '/v2/logout?client_id=' + encodeURIComponent(clientId) +
		'&returnTo=' + encodeURIComponent(returnTo);

	// Clear local SSO state before redirect
	try { _deleteSSOToken(); } catch (e) { /* noop */ }
	try { if (typeof Publisher !== 'undefined' && Publisher && Publisher.publish) Publisher.publish('logout', {}); } catch (e) { /* noop */ }
	try { if (typeof dispatch === 'function' && setUserProfile) dispatch(setUserProfile(null)); } catch (e) { /* noop */ }

	if (typeof window !== 'undefined') {
		window.location.href = logoutURL;
	}
	return false;
};

export const _doUserEllimanSSOLogout = async (props, setUserProfile) => {
	const { authState, authService, dispatch } = props;
	const ssoToken = _getSSOToken();

	const logURL = `https://login.microsoftonline.com/${process.env.ELLIMAN_CLIENT_ID}/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(process.env.ELLIMAN_LOGOUT_REDIRECT_URI)}`;

	logToLocalStorage("sso_user_logout", { logURL });
	const { claims } = ssoToken;
	Publisher.publish("track-mp.userLogin.ssoLogout", {
		user: {
			id: claims.sub,
			...claims
		}
	});
	_deleteSSOToken();
	dispatch(setUserProfile(null));
	Publisher.publish("logout", {});

	window.location.href = logURL;
	return false;
};


export const _checkWarburgAuthorization = (user) => {
	return new Promise((resolve, reject) => {
		let axiosData = {
			url: `${process.env.API_ROOT}/buyerslist/realogy/cbwarburg`,
			method: "get"
		};

		let formattedData = _axiosCall(axiosData)
			.then(res => {
				//console.log(user, res)
				if (user && user.id && res && res.agents && res.agents.filter(agent => agent && agent.companyOfficeAssociation && agent.companyOfficeAssociation.agentOktaIds && agent.companyOfficeAssociation.agentOktaIds.indexOf(user.id) >= 0).length > 0) {
					resolve({ authentication: true, agent: user })

				}
				resolve({ authentication: false, agent: user });

			})
			.catch(error => {
				reject(Error(error));
			});

		// console.log(formattedData)
		return formattedData;
	});

};

export const _setSSOToken = (ssoToken, ssoOrg) => {
	ssoOrg = ssoOrg ? ssoOrg : 'CBWarburg';
	deleteLocalStorage("marketproof", "_ssoTokenType");
	setLocalStorage("marketproof", "_ssoTokenType", ssoOrg);
	return setLocalStorage(ssoOrg, '_SSOToken', ssoToken);
}

export const _deleteSSOToken = () => {
	const ssoOrg = getLocalStorage("marketproof", "_ssoTokenType");
	deleteLocalStorage(ssoOrg, '_SSOToken');
	return deleteLocalStorage("marketproof", "_ssoTokenType");
}
export const _getSSOToken = () => {

	const ssoOrg = getLocalStorage("marketproof", "_ssoTokenType");
	return getLocalStorage(ssoOrg, '_SSOToken')
}

export const _getSSOOrg = () => {
	//return "ELLIMAN";
	return getLocalStorage("marketproof", "_ssoTokenType");
}

export const _doSSOLogout = (props, setUserProfile) => {
	const ssoOrg = getLocalStorage("marketproof", "_ssoTokenType");
	return _doUserSSOLogout(props, setUserProfile, ssoOrg)
}

export const logToLocalStorage = (eventType, data = {}) => {
	return false;
	const key = "sso_logs";

	try {
		if (typeof localStorage === "undefined") return;

		let existing = [];

		try {
			const raw = localStorage.getItem(key);
			existing = raw ? JSON.parse(raw) : [];
		} catch (parseErr) {
			existing = [];
		}

		existing.push({
			event: eventType,
			timestamp: new Date().toISOString(),
			data,
			url: window.location.href
		});

		localStorage.setItem(key, JSON.stringify(existing));
	} catch (storageErr) {
		// Swallow silently — logging failure should not interrupt app flow
	}
};

export const decodeIdToken = (idToken) => {
	try {
		const parts = idToken.split('.');
		if (parts.length !== 3) return null;

		const payload = parts[1];
		const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
		return decoded;
	} catch (e) {
		console.error("Error decoding ID token:", e);
		return null;
	}
};

